import styled from 'styled-components';
import { ORANGE_700 } from '../../constants';

export const ModelLabel = styled.span`
    display: inline-flex;
    align-items: center;
    flex-wrap: wrap;
    column-gap: 0.75rem;
    row-gap: 0.125rem;
    white-space: normal;
`;

export const ShutdownWarning = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 0.25rem;
    color: ${ORANGE_700};
    font-size: 0.75rem;
    line-height: 1.25rem;

    svg {
        flex-shrink: 0;
    }
`;
